import {
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowRightIcon,
} from '@heroicons/react/24/outline';
import type { PerTemplateAthleteRow } from '@/types/channel';

// ─── Props ────────────────────────────────────────────────────────────────────

interface TrendCellProps {
  row: PerTemplateAthleteRow;
}

// ─── TrendCell ────────────────────────────────────────────────────────────────
// ↑ green when last_score - first_score > 2, ↓ red when < -2, → gold flat

export function TrendCell({ row }: TrendCellProps) {
  if (row.last_score === null || row.first_score === null) {
    return <span style={{ color: 'var(--color-text-muted)', fontSize: '13px' }}>—</span>;
  }
  const delta = Math.round(row.last_score) - Math.round(row.first_score);
  const isImproving = delta > 2;
  const isDeclining = delta < -2;
  const sign = delta > 0 ? '+' : '';

  if (isImproving) {
    return (
      <span
        style={{ display: 'inline-flex', alignItems: 'center', gap: '2px', color: 'var(--color-accent)' }}
      >
        <ArrowUpIcon style={{ width: '12px', height: '12px' }} />
        <span style={{ fontSize: '12px', fontWeight: 600 }}>
          {sign}{delta}
        </span>
      </span>
    );
  }
  if (isDeclining) {
    return (
      <span
        style={{ display: 'inline-flex', alignItems: 'center', gap: '2px', color: 'var(--color-accent-red)' }}
      >
        <ArrowDownIcon style={{ width: '12px', height: '12px' }} />
        <span style={{ fontSize: '12px', fontWeight: 600 }}>
          {sign}{delta}
        </span>
      </span>
    );
  }
  return (
    <span
      style={{ display: 'inline-flex', alignItems: 'center', gap: '2px', color: 'var(--color-accent-gold)' }}
    >
      <ArrowRightIcon style={{ width: '12px', height: '12px' }} />
      <span style={{ fontSize: '12px', fontWeight: 600 }}>
        {sign}{delta}
      </span>
    </span>
  );
}

export default TrendCell;
